export const articles = {
  'oshi-no-ko-s3': {
    id: 1,
    slug: 'oshi-no-ko-s3',
    title: '【我推的孩子】第三季 全13话 BD1080P',
    category: 'anime',
    image: 'https://readdy.ai/api/search-image?query=Vibrant%20anime%20illustration%20of%20Oshi%20no%20Ko%20characters%20Aqua%20and%20Ruby%20on%20stage%2C%20idol%20performance%20scene%20with%20colorful%20spotlights%2C%20Japanese%20anime%20art%20style%2C%20dramatic%20composition%20with%20pink%20and%20gold%20lighting&width=1200&height=675&seq=article-anime-01&orientation=landscape',
    excerpt: '偶像题材超高人气作品第三季，星野爱久爱海与星野瑠美衣的复仇故事继续展开。本季剧情更加扣人心弦，制作水准再度提升。',
    content: `<h2>剧情简介</h2>
<p>《我推的孩子》第三季延续了前两季的高质量制作，继续讲述星野爱久爱海（阿库亚）与星野瑠美衣（露比）的故事。本季剧情聚焦于阿库亚深入娱乐圈内部，追查生父下落的主线，同时露比作为偶像团体B小町的新成员，也在为自己的梦想努力。</p>

<h2>制作团队</h2>
<p>动画制作：动画工房<br>原作：赤坂明 × 横枪萌果<br>导演：平牧大辅<br>系列构成：田中仁<br>角色设计：平山宽菜</p>

<h2>声优阵容</h2>
<p>星野爱久爱海（阿库亚）：大冢刚央<br>星野瑠美衣（露比）：伊驹百合绘<br>有马加奈：潘惠美<br>黑川茜：石见舞菜香<br>MEM啾：大久保瑠美</p>

<h2>资源信息</h2>
<p>格式：MKV (HEVC 10bit)<br>分辨率：1920×1080<br>字幕：简繁中日内封<br>音轨：日语 FLAC<br>来源：BDRip</p>

<h2>分集列表</h2>
<p>第01话 - 新的舞台<br>第02话 - 剧本的陷阱<br>第03话 - 演技的真谛<br>第04话 - 幕后的阴影<br>第05话 - 推しの子<br>第06话 - 东京Blade<br>第07话 - 血之记忆<br>第08话 - 父与子<br>第09话 - 真相<br>第10话 - 选择的时刻<br>第11话 - 偶像的觉悟<br>第12话 - 最终幕<br>第13话 - 新章开幕</p>`,
    rating: 9.5,
    downloads: '12.8万',
    size: '24.5GB',
    date: '2026-08-10',
    tags: ['偶像', '悬疑', '转生', 'BDRip', '动画工房'],
    relatedIds: [2, 6, 7],
  },
  'frieren-complete': {
    id: 2,
    slug: 'frieren-complete',
    title: '葬送的芙莉莲 全28话 BDRip 1080P',
    category: 'anime',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20anime%20artwork%20of%20Frieren%20elf%20mage%20with%20her%20party%20walking%20through%20a%20magical%20forest%2C%20fantasy%20theme%2C%20warm%20golden%20sunlight%20filtering%20through%20trees%2C%20emotional%20and%20nostalgic%20atmosphere&width=1200&height=675&seq=article-anime-02&orientation=landscape',
    excerpt: '治愈系奇幻冒险神作，精灵魔法使芙莉莲踏上理解人类的旅程，感动无数观众。荣获多项年度动画大奖。',
    content: `<h2>剧情简介</h2>
<p>打倒了魔王的勇者一行人中的魔法使——芙莉莲，她是一位精灵，拥有着超过千年寿命。她与勇者辛美尔、战士艾泽、僧侣海塔一起，历经十年的冒险后成功打倒了魔王，为世界带来了和平。</p>
<p>对于拥有漫长寿命的精灵来说，和勇者一行人共度的十年只不过是短短一瞬间。于是她在和勇者辛美尔的约定下，独自踏上了旅途。五十年后，芙莉莲再次见到辛美尔时，对方已经垂垂老矣。在勇者辛美尔死后，芙莉莲才意识到自己从未真正"了解人类"，后悔不已的她踏上了"了解人类"的旅程。</p>

<h2>制作团队</h2>
<p>动画制作：MADHOUSE<br>原作：山田钟人 × 阿部司<br>导演：斋藤圭一郎<br>系列构成：铃木智寻<br>角色设计：长泽礼子<br>音乐：Evan Call</p>

<h2>声优阵容</h2>
<p>芙莉莲：种崎敦美<br>菲伦：市之濑加那<br>休塔尔克：小林千晃<br>辛美尔：冈本信彦<br>艾泽：上田耀司<br>海塔：东地宏树</p>

<h2>资源信息</h2>
<p>格式：MKV (HEVC 10bit)<br>分辨率：1920×1080<br>字幕：简繁日英内封<br>音轨：日语 DTS-HDMA 5.1ch<br>来源：BDRip 全卷</p>`,
    rating: 9.8,
    downloads: '18.5万',
    size: '42.8GB',
    date: '2026-08-08',
    tags: ['奇幻', '治愈', '冒险', 'BDRip', 'MADHOUSE'],
    relatedIds: [1, 5, 8],
  },
  'spy-family-s2': {
    id: 3,
    slug: 'spy-family-s2',
    title: '间谍过家家 第二季 全12话',
    category: 'anime',
    image: 'https://readdy.ai/api/search-image?query=Spy%20x%20Family%20anime%20illustration%20of%20the%20Forger%20family%20having%20dinner%20together%2C%20warm%20family%20moment%2C%20pastel%20interior%20lighting%2C%20Japanese%20anime%20art%20style%2C%20cozy%20and%20humorous%20atmosphere&width=1200&height=675&seq=article-anime-03&orientation=landscape',
    excerpt: '间谍父亲、杀手母亲、读心术女儿组成的伪装家庭搞笑日常。第二季加入更多新角色，笑点十足。',
    content: `<h2>剧情简介</h2>
<p>每个人都有着不让任何人知道的一面——这是一个世界各国在暗地里展开激烈情报战的时代。为了执行任务，西国能力最强的间谍"黄昏"必须组建一个临时家庭。然而，他的"女儿"安雅是一个能读懂他人内心的超能力者，"妻子"约尔则是一个杀手。三人互相隐瞒真实身份，开始了奇妙的共同生活。</p>
<p>第二季中，佛杰一家将面临更多挑战，新的角色陆续登场，世界的和平（与家庭的安宁）能否维持？</p>

<h2>制作团队</h2>
<p>动画制作：WIT STUDIO × CloverWorks<br>原作：远藤达哉<br>导演：古桥一浩<br>角色设计：岛田和晃<br>音乐：(K)NoW_NAME</p>

<h2>资源信息</h2>
<p>格式：MKV/MKV<br>分辨率：1920×1080<br>字幕：简繁中文<br>音轨：日语 AAC<br>来源：WebRip</p>`,
    rating: 9.3,
    downloads: '15.2万',
    size: '18.6GB',
    date: '2026-08-05',
    tags: ['喜剧', '家庭', '间谍', 'WIT STUDIO', 'CloverWorks'],
    relatedIds: [1, 8, 9],
  },
  'dandadan-complete': {
    id: 5,
    slug: 'dandadan-complete',
    title: '当哒当 全12话 BD1080P',
    category: 'anime',
    image: 'https://readdy.ai/api/search-image?query=Dandadan%20anime%20battle%20scene%20with%20Momo%20and%20Okarun%20fighting%20supernatural%20entities%2C%20dynamic%20action%20composition%2C%20neon%20pink%20and%20electric%20blue%20colors%2C%20Japanese%20anime%20style&width=1200&height=675&seq=article-anime-05&orientation=landscape',
    excerpt: '超自然战斗喜剧，幽灵与外星人题材的疯狂碰撞，MAPPA制作，视觉冲击力爆表。',
    content: `<h2>剧情简介</h2>
<p>女高中生绫濑桃相信幽灵存在但不信外星人，她的同班同学高仓健（通称厄卡伦）则相信外星人存在但不信幽灵。两人为了证明各自的观点，分别前往灵异地点和UFO圣地——结果两人都错了，幽灵和外星人都真实存在！</p>
<p>在一连串超自然事件后，桃获得了觉醒的超能力，而厄卡伦则被诅咒附身，获得了强大的变身能力。两人携手面对接连不断的超自然威胁。</p>

<h2>制作团队</h2>
<p>动画制作：MAPPA<br>原作：龙幸伸<br>导演：山代风我<br>系列构成：濑古浩司<br>音乐：牛尾宪辅</p>

<h2>资源信息</h2>
<p>格式：MKV (HEVC 10bit)<br>分辨率：1920×1080<br>字幕：简繁中文<br>音轨：日语 FLAC<br>来源：BDRip</p>`,
    rating: 9.1,
    downloads: '10.6万',
    size: '19.2GB',
    date: '2026-07-28',
    tags: ['战斗', '喜剧', '超自然', 'MAPPA'],
    relatedIds: [1, 7, 11],
  },
  'solo-leveling-s2': {
    id: 11,
    slug: 'solo-leveling-s2',
    title: '我独自升级 第二季 全13话 BD1080P',
    category: 'anime',
    image: 'https://readdy.ai/api/search-image?query=Solo%20Leveling%20anime%20illustration%20of%20Sung%20Jinwoo%20surrounded%20by%20shadow%20soldiers%20in%20epic%20battle%2C%20dark%20fantasy%20theme%2C%20purple%20aura%20and%20glowing%20eyes%2C%20Korean%20anime%20adaptation%20style&width=1200&height=675&seq=article-anime-11&orientation=landscape',
    excerpt: '韩漫改编现象级作品，成振宇从最弱猎人成长为最强君王的热血故事。第二季战斗场面全面升级。',
    content: `<h2>剧情简介</h2>
<p>十年前，世界各地突然出现了连接异次元与现世的"门"，被称为"猎人"的觉醒者们开始以攻略门内 dungeon 为生。成振宇是被称为"人类最弱兵器"的E级猎人，在一次几乎全员覆灭的 double dungeon 攻略中，他获得了神秘的"系统"，成为了能够无限升级的"玩家"。</p>
<p>第二季中，振宇将面对更强大的敌人，同时逐步揭开"系统"背后的真相。济州岛突袭篇震撼上演！</p>

<h2>制作团队</h2>
<p>动画制作：A-1 Pictures<br>原作：Chugong × DUBU(REDICE STUDIO)<br>音乐：泽野弘之</p>

<h2>资源信息</h2>
<p>格式：MKV (HEVC 10bit)<br>分辨率：1920×1080<br>字幕：简繁中文<br>音轨：日语 AAC / 韩语 AAC<br>来源：BDRip</p>`,
    rating: 9.6,
    downloads: '21.7万',
    size: '21.3GB',
    date: '2026-06-15',
    tags: ['奇幻', '战斗', '升级', 'A-1 Pictures', '韩漫'],
    relatedIds: [7, 9, 12],
  },
  'chainsaw-man-s2': {
    id: 6,
    slug: 'chainsaw-man-s2',
    title: '电锯人 第二季 蕾塞篇 全12话',
    category: 'anime',
    image: 'https://readdy.ai/api/search-image?query=Chainsaw%20Man%20Reze%20arc%20anime%20illustration%20of%20Denji%20and%20Reze%20at%20summer%20festival%20with%20fireworks%2C%20romantic%20yet%20melancholic%20atmosphere%2C%20warm%20summer%20night%20colors%2C%20Japanese%20anime%20style&width=1200&height=675&seq=article-anime-06&orientation=landscape',
    excerpt: '藤本树原作，电次与蕾塞的夏日恋爱物语。MAPPA倾力制作，电影级画面水准。',
    content: `<h2>剧情简介</h2>
<p>电锯人第二季"蕾塞篇"是原作中最为人称道的篇章之一。电次在雨天的电话亭邂逅了神秘美少女蕾塞，两人迅速陷入热恋。然而蕾塞的真实身份是苏联培养的"炸弹魔人"，接近电次是为了夺取他的心脏。</p>
<p>在咖啡厅、校园、夏日祭典和烟花大会的背景下，一段甜蜜又残酷的恋爱故事展开。这篇章充满了藤本树标志性的浪漫主义与残酷现实的碰撞。</p>

<h2>制作团队</h2>
<p>动画制作：MAPPA<br>原作：藤本树<br>导演：中山龙<br>音乐：牛尾宪辅</p>

<h2>资源信息</h2>
<p>格式：MKV (HEVC 10bit)<br>分辨率：1920×1080<br>字幕：简繁中文<br>音轨：日语 FLAC<br>来源：BDRip</p>`,
    rating: 9.4,
    downloads: '16.8万',
    size: '20.1GB',
    date: '2026-07-20',
    tags: ['战斗', '恋爱', '黑暗', 'MAPPA', '藤本树'],
    relatedIds: [1, 5, 7],
  },
};

export const getArticleBySlug = (slug: string) => {
  return articles[slug as keyof typeof articles] || null;
};

export const getRelatedArticles = (ids: number[]) => {
  return ids.map(id => {
    const article = Object.values(articles).find(a => a.id === id);
    return article || null;
  }).filter(Boolean);
};